import React from 'react';
import {AppRouteGroupProps, AppRouteProps, BreadcrumbItemProps} from '../../types/AppRoutesPropType';
import {adminPaths} from './paths';
import {PermissionLevel} from '../../types/common/Permissions';

const sectionBreadcrumbs = [new BreadcrumbItemProps("Administration")];

const adminRoutes = [
  new AppRouteProps("Re-initialise search indexes", adminPaths.DevReindexPage, React.lazy(() => import('./DevReindex')), sectionBreadcrumbs),
  new AppRouteProps("Manage subscribed emails", adminPaths.ManageUnsubscribe, React.lazy(() => import('./ManageUnsubscribe')), sectionBreadcrumbs),
  new AppRouteProps("Mass advisor update", adminPaths.MassAdvisorUpdatePage, React.lazy(() => import('./MassAdvisorUpdate')), sectionBreadcrumbs),
  new AppRouteProps("Mass Tag Assign", adminPaths.MassTagUpdatePage, React.lazy(() => import('./MassTagUpdate')), sectionBreadcrumbs),
  new AppRouteProps("Mass Achievement Update", adminPaths.MassAchievementUpdate, React.lazy(() => import('./MassAchievementUpdate')), sectionBreadcrumbs),

]

const adminRoutesConfig = [
  new AppRouteGroupProps(PermissionLevel.ADVISOR, adminRoutes)
];
export default adminRoutesConfig;
